import type { RenderLink } from '@pms-digital/design-system';
import { Link } from '@tanstack/react-router';

/** `Link` wants a known path and the package hands over a resolved `href` (`/resultat/<id>`): typed as a static route, resolved at run time. */
type CheminCarte = '/historique';

/**
 * The `renderLink` of the design system components that link (the title of a `Card`): the `Link`
 * of the router, so a click navigates without reloading the page. The package hands over a plain
 * `href` (`/resultat/<id>`), which the router resolves against its route tree.
 */
export const renderLienRouteur: RenderLink = ({ href, children, ...reste }) => (
  <Link to={href as CheminCarte} {...reste}>
    {children}
  </Link>
);
